module.exports = __webpack_public_path__ + "static/media/galeria_elo_13.2e484c17.jpg";